import { Trophy, Lock } from "lucide-react";
import { cn } from "@/lib/utils";

export interface Achievement {
  title: string;
  icon: string;
  achieved: boolean;
  progress?: { current: number; total: number };
}

interface AchievementsSectionProps {
  achievements: Achievement[];
}

export const AchievementsSection = ({ achievements }: AchievementsSectionProps) => {
  const achieved = achievements.filter(a => a.achieved);
  const upcoming = achievements.filter(a => !a.achieved);

  return (
    <div className="space-y-6">
      {/* Unlocked */}
      {achieved.length > 0 && (
        <div>
          <h3 className="text-sm font-medium mb-3 flex items-center gap-2">
            <Trophy className="h-4 w-4 text-wellness-peach" /> Logros Alcanzados
          </h3>
          <div className="space-y-2">
            {achieved.map((m, i) => (
              <div key={i} className="flex items-center gap-3 px-4 py-3 rounded-xl border border-primary/20 bg-secondary shadow-sm">
                <span className="text-xl shrink-0">{m.icon}</span>
                <span className="text-sm font-medium text-foreground flex-1">{m.title}</span>
                <span className="text-[10px] font-bold text-primary uppercase bg-primary/10 px-2 py-1 rounded">Logrado</span>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Upcoming */}
      {upcoming.length > 0 && (
        <div>
          <h3 className="text-sm font-medium mb-3 flex items-center gap-2 text-muted-foreground">
            <Lock className="h-4 w-4" /> Próximos Logros
          </h3>
          <div className="space-y-2">
            {upcoming.map((m, i) => {
              const p = m.progress ? Math.round((m.progress.current / m.progress.total) * 100) : 0;
              return (
                <div key={i} className="flex flex-col gap-2 px-4 py-3 rounded-xl border border-border bg-card opacity-80">
                  <div className="flex items-center gap-3">
                    <span className="text-xl grayscale opacity-50 shrink-0">{m.icon}</span>
                    <span className="text-sm text-muted-foreground flex-1">{m.title}</span>
                    {m.progress && (
                      <span className="text-xs font-bold text-muted-foreground">
                        {m.progress.current}/{m.progress.total}
                      </span>
                    )}
                  </div>
                  {m.progress && (
                    <div className="w-full h-1.5 bg-secondary rounded-full overflow-hidden mt-1">
                      <div className="h-full bg-muted-foreground/30 rounded-full" style={{ width: `${p}%` }} />
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
};
